// src/pages/Portfolio.jsx
import { useState } from "react";
import PortfolioCard from "../components/PortfolioCard";
import usePageTitle from "../hooks/usePageTitle";
import { PORTFOLIO, TIPOS } from "../data/portfolio";
import "./Portfolio.css";

function Portfolio() {
  usePageTitle("Portfólio — D-Rec Produções");
  const [filter, setFilter] = useState("Todos");

  // Só mostra filtros de tipos que têm pelo menos um item
  const tiposPresentes = TIPOS.filter((t) => PORTFOLIO.some((i) => i.tipo === t));
  const filtros = ["Todos", ...tiposPresentes];

  const visible = filter === "Todos" ? PORTFOLIO : PORTFOLIO.filter((i) => i.tipo === filter);

  return (
    <section className="portfolio">
      <div className="section-head">
        <span className="eyebrow">Portfólio</span>
        <h1 className="section-title">Imóveis que já filmamos</h1>
        <p className="portfolio-intro">
          Uma seleção de captações aéreas e tours em vídeo. Novos imóveis entram aqui toda
          semana.
        </p>
      </div>

      <div className="portfolio-filters">
        {filtros.map((f) => (
          <button
            key={f}
            type="button"
            className={`filter-btn ${filter === f ? "filter-btn--active" : ""}`}
            onClick={() => setFilter(f)}
          >
            {f}
          </button>
        ))}
      </div>

      {visible.length > 0 ? (
        <div className="portfolio-grid">
          {visible.map((item) => (
            <PortfolioCard key={item.id} item={item} />
          ))}
        </div>
      ) : (
        <p className="portfolio-empty">
          Ainda não temos imóveis deste tipo publicados. Em breve.
        </p>
      )}
    </section>
  );
}

export default Portfolio;
